import React from "react";
import { getSession } from "../redux/actions/authActions";
import "./db.scss";
import SideProfileIcon from "../../assets/SideProfileIcon";
import { useSelector } from "react-redux";
import CartIconBlack from "../../assets/CartIconBlack";
import { getProfileSession } from "../redux/actions/dbactions/profileActions";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

export const Header = ({ pageTitle, icon }) => {
  const { userFirstname, user_last_name, role } = getSession();
  const { profileData } = getProfileSession();
  const history = useHistory();

  const cartItems = useSelector((state) => state?.cart?.cartItems);
  const facilityId =
    (cartItems && cartItems?.[0]?.svcsc_cart_jsn?.order_svcf_id) || null;

  const handleNavLinkClick = (e, url) => {
    if (
      profileData.user_has_profile_yn !== "Y" &&
      url !== "/dashboard/profile"
    ) {
      e.preventDefault();
      toast.dismiss();
      toast.error("Please fill your profile first to access other pages");
    } else {
      history.push(url);
    }
  };

  return (
    <div className=" bg-white border-b border-[#E7E7E9] sticky top-0 z-30 w-full hidden sm:block">
      <div className="w-full h-[74px] px-8 flex items-center justify-between">
        <h5 className="pl-10 tab:pl-0 text-[#4A4E5A] font-normal text-sm gap-[6px] flex items-center mb-0">
          {icon}
          {pageTitle}
        </h5>
        <div className="flex items-center gap-8">
          <button
            className="relative ml-8"
            onClick={(e) => {
              handleNavLinkClick(
                e,
                `/dashboard/cart/${facilityId}?patient=null`
              );
            }}
          >
            <CartIconBlack className="size-[40px]" />
            <span className="absolute -right-1 -top-1 bg-[#132573] size-5 inline-flex rounded-full items-center justify-center text-white text-xs">
              {(cartItems &&
                cartItems[0]?.svcsc_cart_jsn?.service_order_line?.length) ||
                0}
            </span>
          </button>
          <div className="flex items-center relative">
            <p className="user-name mb-0 font-semibold">
              {userFirstname +
                " " +
                user_last_name.charAt(0) +
                "( " +
                role +
                " )"}
            </p>
          </div>
          {userFirstname && (
            <div className="bg-[#DBDBDB] border-[#E7E7E9] p-2.5 ml-2 rounded-full drop-shadow-md shadow-[#A4ACB933]">
              <SideProfileIcon />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
